import { createFragmentContainer, graphql } from 'react-relay';
import FormTemplate from './FormTemplateComponent';

export default createFragmentContainer(FormTemplate, {
  node: graphql`
    fragment FormTemplateContainer_node on FormTemplate {
      id
      title
      schema
      ui_schema
      data
      brand {
        id
        logo_url
        header
      }
    }
  `,
  viewer: graphql`
  fragment FormTemplateContainer_viewer on User {
    id
    first_name
    last_name
    primary_brand {
      id
    }
    ...SearchContainer_viewer
  }
  `,
});



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Form/FormTemplateContainer.js